import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Table as action } from '../../redux/actions';

/**
 * Returns all **table** information stored in the database
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const table = (properties) => {
  const props = assign(properties);

  fetch(endpoint('/table-list'), options())
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.set(response.Data));
        }
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default table;
